/**
 * Godot's padded atlas layout. Godot copies each tile, frame 0, to its atlas coordinates on a grid
 * of cells one texel wider on each side than the texture region, and draws it from there
 * (`tile_set.cpp:5333-5345`, `:5638`).
 */
/** The cell padding on each side of a tile. */
const PADDING = 1;
/** `get_runtime_tile_texture_region` with padding: the tile's own `region` size, one texel into its cell. */
export function paddedTileRegion(source, atlasCoords, region) {
    const { textureRegionSize: cell } = source;
    return {
        x: atlasCoords.x * (cell.x + 2 * PADDING) + PADDING,
        y: atlasCoords.y * (cell.y + 2 * PADDING) + PADDING,
        width: region.width,
        height: region.height,
    };
}
//# sourceMappingURL=paddedAtlas.js.map